__turbopack_context__.v({
  "reportThisEventButton": "ReportThisEventButton-module-scss-module__FNg4YW__reportThisEventButton",
  "reportThisEventButtonText": "ReportThisEventButton-module-scss-module__FNg4YW__reportThisEventButtonText",
});
